<template>
    <b-container class="mb-5">
        <PageHeader :linkto="'/Payment/ShopCard'" :linkttitle="'返回'" title=""></PageHeader>
        <b-container>
            <b-card class="text-center">
                <b-img :src="require('@/assets/ui/finish.svg')" width="350px" fluid alt="Fluid image"></b-img>
                <h4 class="text-muted">完成付款</h4>
                <p class="text-muted">訂單編號：{{ paySuccessData.MerchantTradeNo }}</p>
                <p class="text-muted">付款金額：{{ paySuccessData.TradeAmt }}</p>
                <p class="text-muted">付款方式：信用卡</p>
                <b-button variant="outline-primary" to="/Home">返回主選單</b-button>
            </b-card>
        </b-container>
        <AnaLoading :show="pageloading"></AnaLoading>
    </b-container>
</template>

<script>
import { mapState } from 'vuex'
import PageHeader from '@/components/PageHeader.vue'
import AnaLoading from '@/components/AnaLoading.vue'
import { toastsModel } from '@/service/commuse'

export default {
  name: 'SalesEcpay',
  components: {PageHeader, AnaLoading},
  computed: {
    ...mapState(['orderpurchase']),
  },
  data () {
    return {
      pageloading: true,
      htmlData: '',
      ifmsrc: '',
      payErrorshow: false,
      paySuccessShow: false,
      paySuccessData: {
        MerchantTradeNo: '',
        TradeAmt: ''
      }

    }
  },
  created () {

    if (Object.keys(this.orderpurchase).length !== 0) {
      this.ECpay(this.orderpurchase)
    } else {
      this.$router.push('/Payment/ShopCard')
    }

  },
  mounted () {
    let self = this
    window.addEventListener('message', function (e) {

        if (typeof e.data == 'string') {
          let jsonData = JSON.parse(e.data)
          if (jsonData.RtnCode == '1') {
            self.successPay(jsonData)
          }
        }
      }
    )

  },
  methods: {
    successPay (data) {
      this.paySuccessShow = true
      this.paySuccessData.MerchantTradeNo = data.MerchantTradeNo
      this.paySuccessData.TradeAmt = data.TradeAmt

      this.$store.dispatch('actionGetMemberInfo', {})

    },
    ECpay (data) {
      let _this = this
      // 檢查裝置類型
      let IsMobileAgent
      IsMobileAgent = this.getIsMobileAgent()
      this.$store.dispatch('actionSalesECpay', data
      ).then((res) => {

          document.open();
          document.write(res);
          document.close();


        // let sMsg = res.data
        // if (IsMobileAgent) {
        //   this.ifmsrc = sMsg.SPCheckOut + '?MerchantID=' + sMsg.MerchantID + '&SPToken=' + sMsg.SPToken + '&PaymentType=' + sMsg.PaymentType
        // } else {
        //   this.ifmsrc = sMsg.SPCheckOut + '?MerchantID=' + sMsg.MerchantID + '&SPToken=' + sMsg.SPToken + '&PaymentType=' + sMsg.PaymentType
        // }
        this.pageloading = false

      }).catch((res) => {
        if (res.status == 400) {
          toastsModel(this, '系統忙碌中請稍候再試')
          this.payErrorshow = true
          this.pageloading = false
        }
      })
    },

    getIsMobileAgent () {
      var IsMobileAgent = false
      var userAgent = navigator.userAgent
      var CheckMobile = new RegExp('android.+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino')
      var CheckMobile2 = new RegExp('mobile|mobi|nokia|samsung|sonyericsson|mot|blackberry|lg|htc|j2me|ucweb|opera mini|mobi|android|iphone')
      if (CheckMobile.test(userAgent) || CheckMobile2.test(userAgent.toLowerCase())) {
        IsMobileAgent = true
      }
      return IsMobileAgent
    }
  }
}
</script>

